App.Views.Geofence = {

    render: function (geofenceObject, organizations) {
        var tabName = 'Geofence';

        if (!Monet.Session.GeofenceMaps) {
            Monet.Session.GeofenceMaps = {};
        }

        var entity = 'Geofence';
        var pageLayout = null;

        if (geofenceObject) {
            pageLayout = App.Forms.Geofence.layout['edit'];
        } else {
            pageLayout = App.Forms.Geofence.layout['new']; //new is reserved word.
        }

        //Isso foi adicionado aqui, pois o evento de change do plugin de cor
        //so funciona se a funcao for setada na criacao do elemento.
        var formOptions = {
            colorpicker: {
                change: function (escope) {
                    return function (color) {
                        (escope).redrawPolygon(color);
                    };
                }(this)
            }
        };

        var form = new Monet.Builder.Form.Vertical(pageLayout, entity);
        form.setOptions(formOptions);

        var title = Monet.I18n.getResourcesByKey(pageLayout.userInterfaceAction.userInterface.description);
        form.help = new Monet.UI.Help(entity, title);

        Monet.Session.GeofenceMaps.form = form;

        this.createTab(tabName);
        this.populateSidebar(organizations, form.render());

        this.startMap();

        this.threatShowHideSideBar();

        Monet.Session.GeofenceMaps.map.invalidateSize();

        this.addDrawTool(form.getField('color').getValue());

        if (geofenceObject) {

            var latLngs = this.getGeofencePoints(geofenceObject);

            this.addGeofenceInfo(form, geofenceObject);
            this.drawGeofences(latLngs, geofenceObject.color);

        }

    },

    threatShowHideSideBar: function () {
        var sidebarList = JSON.parse(Monet.Session.sessionStorage.sidebar);
        var filteredSidebars = sidebarList.filter(function (object) {

            return object.screen === 'Geofence';

        });

        if (filteredSidebars[0].show) {

            this.afterShowSideBar();

        } else {

            this.beforeHideSideBar();
        }
    },

    beforeHideSideBar: function () {
        const mapContainer = document.getElementById('geofenceMapContainer');
        const toolbarContainer = document.querySelector('#Geofence .toolbarContainer');

        const widthToolbarMap = window.document.body.getBoundingClientRect().width - 20;

        mapContainer.style.left = `0px`;
        toolbarContainer.style.width = `${widthToolbarMap}px`;

        Monet.Session.GeofenceMaps.map.invalidateSize();
    },

    afterShowSideBar: function () {
        const SIDEBAR_WIDTH = 281;
        const mapContainer = document.getElementById('geofenceMapContainer');
        const toolbarContainer = document.querySelector('#Geofence .toolbarContainer');

        const widthToolbarMap = window.document.body.getBoundingClientRect().width - 320;

        mapContainer.style.left = `${SIDEBAR_WIDTH}px`;
        toolbarContainer.style.width = `${widthToolbarMap}px`;

        Monet.Session.GeofenceMaps.map.invalidateSize();
    },

    createTab: function (tabName, callback) {

        var error                  = null,
            _callback              = null,
            that                   = this;

        try {
            _callback = callback;

            var error    = null,
                sidebar  = null,
                tab      = null,
                fragment = null,
                divAllContent;

            try {

                tab = document.getElementById(tabName);
                if (tab) {
                    Monet.Form.checkFormTemplate('Geofence');
                    divAllContent = document.querySelector('#Geofence #form_and_grid');
                    divAllContent.innerHTML = "";
                    fragment = document.createDocumentFragment();

                    sidebar = new Monet.UI.SidebarTransition('left');
                    sidebar.setCallbackBeforeHide(App.Views.Geofence.beforeHideSideBar);
                    sidebar.setCallbackAfterShow(App.Views.Geofence.afterShowSideBar);

                    Monet.Session.GeofenceMaps.sidebar = sidebar;

                    fragment.appendChild(sidebar.render());
                    sidebar.setContent(that.renderMapContainer());

                    divAllContent.appendChild(fragment);
                    tab.appendChild(divAllContent);

                    sidebar.init();

                    if (_callback) {
                        _callback(tabName);
                    }

                    window.addEventListener("resize", function (scope) {
                        return function () {
                            scope.threatShowHideSideBar();
                        };

                    }(this));

                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    'Error on execute callback after add new tab on Geofence.', e);
                error.console();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on create tab on Geofence.');
            error.console();

        }

    },

    populateSidebar: function (organizations, content) {
        var sidebar = Monet.Session.GeofenceMaps.sidebar;

        var filters = new Greenmile.Geofence.SideBarFilters(sidebar, content);
        filters.appendFilters(organizations);
    },


    clear: function () {

        var form = Monet.Session.GeofenceMaps.form;
        form.clearAllFields();

    },

    addGeofenceInfo: function (form, geofenceObject) {

        if (geofenceObject) {

            form.setEntityId(geofenceObject.id);

            var fields = form.getFields();
            for (var x in fields) {
                if (fields.hasOwnProperty(x)) {
                    var value = geofenceObject[x];
                    if (x.indexOf('.id') !== -1) {
                        value = geofenceObject[x.split('.')[0]].id;
                    }
                    fields[x].setValue(value);
                }
            }

            form.getField('color').setColor(geofenceObject.color);
        }
    },

    getGeofencePoints: function (geofenceObject) {

        const geofenceGeometry = geofenceObject.geofenceGeometry;
        let positions = [];

        if (geofenceGeometry && geofenceGeometry.positions) {
            positions = geofenceGeometry.positions;
        }

        const latLngs = positions.map(({ latitude, longitude }) => ([latitude, longitude]));
        latLngs.splice(latLngs.length - 1);

        return latLngs;
    },

    /**
     * Inicializa o mapa.
     * TODO: verificar como componentizar isso tudo
     * @returns {null}
     */
    startMap: function () {

        var error = null;

        try {

            var map;
            var baseLayer;
            var selectorToolbar = '#Geofence .toolbarContainer';
            var selector = "geofenceMapContainer";

            map = Greenmile.Map.Utility.createDefaultMap(selector);
            baseLayer = Greenmile.Map.Utility.createBaseLayer();

            map.addLayer(baseLayer);

            Monet.Session.GeofenceMaps.name = 'GeofenceMaps';
            Monet.Session.GeofenceMaps.map = map;
            Monet.Session.GeofenceMaps.mapBaseLayer = baseLayer;

            if (Monet.Session.GeofenceMaps) {
                Monet.Session.GeofenceMaps = Monet.Session.GeofenceMaps;
            }

            var options = {
                sourceSessionData: Monet.Session.GeofenceMaps
            };

            var help = options.sourceSessionData.form.help;

            var toolbar = new Greenmile.Toolbar.Map(map, selectorToolbar, options, help);

            toolbar.enable([
                toolbar.actions.searchAddressOnMap,
                toolbar.actions.street,
                toolbar.actions.zoom,
                toolbar.actions.source,
                toolbar.actions.points,
                toolbar.actions.pois,
                toolbar.actions.geofences,
            ]);

            toolbar.render();

            return map;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on initialize Geofence map", e);
            error.console();

        }

    },

    addDrawTool: function (color) {

        var map = Monet.Session.GeofenceMaps.map;

        var drawnItems = new L.FeatureGroup();
        var groupCached = Monet.Session.GeofenceMaps.featureGroup;

        if (groupCached) {
            map.removeLayer(groupCached);
            groupCached = {};
        }

        map.addLayer(drawnItems);

        this.I18nLeafletDraw();

        var options = {
            position: 'topright',
            draw: {
                // Turns off this drawing tools that is not interesting to us
                polyline: false,
                marker: false,
                rectangle: false,
                circle: false,

                polygon: {
                    allowIntersection: false, // Restricts shapes to simple polygons
                    drawError: {
                        color: '#e1e100', // Color the shape will turn when intersects
                        message: Monet.I18n.getResourcesByKey('geofence.intersectionError') // Message that will show when intersect
                    },
                    shapeOptions: {
                        color: color || '#0000FF'
                    }
                }
            },
            edit: {
                featureGroup: drawnItems, //REQUIRED!!
                remove: false
            }
        };

        var drawControl = new L.Control.Draw(options);

        map.addControl(drawControl);
        this.setListeners(map, drawnItems);

        var divMenu = document.querySelector('#Geofence  div.leaflet-draw-section div.leaflet-draw-toolbar.leaflet-bar .leaflet-draw-edit-edit');
        var remove = document.createElement('a');
        remove.className = 'leaflet-draw-edit-remove leaflet-disabled';
        remove.href = "javascript: App.Views.Geofence.removeGeofence();";
        L.DomEvent.on(remove, 'dblclick', L.DomEvent.stopPropagation);

        divMenu.parentNode.appendChild(remove);

        var drawSelector = "div.leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top";

        Monet.Session.GeofenceMaps.featureGroup = drawnItems;
        Monet.Session.GeofenceMaps.drawControl = drawControl;
        Monet.Session.GeofenceMaps.drawPolygonDiv = document.querySelector(drawSelector);

    },

    removeGeofence: function () {
        const enable = document.querySelector('#Geofence .leaflet-draw-edit-remove.leaflet-enable');
        if (enable) {
            const removePolygonAction = () => {
                const group = Monet.Session.GeofenceMaps.featureGroup;

                if (group) {
                    group.clearLayers();
                }
                this.enableDraw();
            };
        
            new Greenmile.Components.AlertModal('geofence.confirm.remove.polygon',
                null,
                removePolygonAction)
            .show();

        }

    },

    setListeners: function (map, drawnItems) {
        map.on('draw:created', function (escope) {

            return function (e) {
                var layer = e.layer;

                drawnItems.clearLayers();
                drawnItems.addLayer(layer);

                Monet.Session.GeofenceMaps.polygon = e.layer._latlngs;
                escope.disableDraw();
            };
        }(this));

        map.on('draw:drawstart', function () {

            var form = Monet.Session.GeofenceMaps.form;
            var control = Monet.Session.GeofenceMaps.drawControl;

            var color = form.getField('color').getValue();
            control.setDrawingOptions({
                polygon: {
                    shapeOptions: {
                        color: color
                    }
                }
            });
        });

        map.on('draw:deleted', function (escope) {

            return function () {
                escope.enableDraw();
            };
        }(this));
    },


    drawGeofences: function (points, color) {
        var drawnItems = Monet.Session.GeofenceMaps.featureGroup;
        var map = Monet.Session.GeofenceMaps.map;

        if (points.length) {

            var options = { color: color };
            var polygon = new L.Polygon(points, options);

            drawnItems.clearLayers();
            drawnItems.addLayer(polygon);

            map.fitBounds(points);
            this.disableDraw();
        }
    },

    enableDraw: function () {
        var divDraw = Monet.Session.GeofenceMaps.drawPolygonDiv;
        if (divDraw) {
            divDraw.style.display = 'block';
        }
        var remove = document.querySelector('#Geofence  a.leaflet-draw-edit-remove.leaflet-enable');
        remove.className = 'leaflet-draw-edit-remove leaflet-disabled';
    },

    disableDraw: function () {

        var divDraw = Monet.Session.GeofenceMaps.drawPolygonDiv;

        if (divDraw) {
            divDraw.style.display = 'none';
        }

        var remove = document.querySelector('#Geofence  a.leaflet-draw-edit-remove.leaflet-disabled');
        if (remove) {
            remove.className = 'leaflet-draw-edit-remove leaflet-enable';
        }

    },

    renderMapContainer: function () {

        var error        = null,
            divAdjust,
            toolbarContainer,
            mapContainer = null;

        try {

            toolbarContainer = document.createElement('div');
            toolbarContainer.className = 'toolbarContainer';

            mapContainer = document.createElement('div');
            mapContainer.id = 'geofenceMapContainer';
            mapContainer.className = 'leaflet-container';

            divAdjust = document.createElement('div');
            divAdjust.id = 'adjustsLayoutContainer';
            divAdjust.appendChild(toolbarContainer);
            divAdjust.appendChild(mapContainer);

            return divAdjust;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on generate initial content.', e);
            error.console();

        }

    },

    redrawPolygon: function (color) {
        const layer = Monet.Session.GeofenceMaps.featureGroup.getLayers()[0];

        if (layer) {
            this.drawGeofences(layer.getLatLngs(), color);
        }
    },

    I18nLeafletDraw: function () {

        L.drawLocal.draw.toolbar.actions.title = Monet.I18n.getResourcesByKey('geofence.draw.cancel');
        L.drawLocal.draw.toolbar.actions.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');

        L.drawLocal.draw.toolbar.undo.title = Monet.I18n.getResourcesByKey('geofence.undo.deletethelastpoint');
        L.drawLocal.draw.toolbar.undo.text = Monet.I18n.getResourcesByKey('geofence.undo.deletethelastpoint');

        L.drawLocal.draw.toolbar.buttons.polygon = Monet.I18n.getResourcesByKey('geofence.draw');
        L.drawLocal.draw.handlers.polyline.error = '<strong>' + Monet.I18n.getResourcesByKey('geofence.draw.error') +
            '</strong>' + Monet.I18n.getResourcesByKey('geofence.intersectionError');
        L.drawLocal.draw.handlers.polygon.tooltip.start = Monet.I18n.getResourcesByKey('geofence.draw.start');
        L.drawLocal.draw.handlers.polygon.tooltip.cont = Monet.I18n.getResourcesByKey('geofence.draw.continue');
        L.drawLocal.draw.handlers.polygon.tooltip.end = Monet.I18n.getResourcesByKey('geofence.draw.end');

        L.drawLocal.edit.toolbar.actions.save.title = Monet.I18n.getResourcesByKey('geofence.button.save');
        L.drawLocal.edit.toolbar.actions.save.text = Monet.I18n.getResourcesByKey('geofence.button.save');
        L.drawLocal.edit.toolbar.actions.cancel.title = Monet.I18n.getResourcesByKey('geofence.draw.cancel.editions');
        L.drawLocal.edit.toolbar.actions.cancel.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');

        L.drawLocal.edit.handlers.edit.tooltip.text = Monet.I18n.getResourcesByKey('geofence.draw.instructions.edit');
        L.drawLocal.edit.handlers.edit.tooltip.subtext = Monet.I18n.getResourcesByKey('geofence.draw.instructions.cancel');

        L.drawLocal.edit.handlers.edit.tooltip.text = Monet.I18n.getResourcesByKey('geofence.button.cancel');
        L.drawLocal.edit.handlers.remove.tooltip.text = Monet.I18n.getResourcesByKey('geofence.draw.instructions.delete');

    }

};
